var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "xueShengDanXiangXunLian" }, [
    _c(
      "div",
      {
        staticClass: "student_training_left",
        style: "height:" + (_vm.height - 90) + "px"
      },
      [
        _c("div", { staticClass: "encourage_words" }, [
          _c("p", [
            _vm._v(
              _vm._s(_vm.famousQuotesData.content) +
                "—" +
                _vm._s(_vm.famousQuotesData.author)
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "course_task_progress" }, [
          _c("h2", [
            _vm._v("课程任务进度"),
            _c("span", [
              _vm._v("完成任务"),
              _c("i", [
                _vm._v(_vm._s(_vm.taskProgressData.finishTaskNum) + "个")
              ]),
              _vm._v("/ 总任务"),
              _c("i", [
                _vm._v(_vm._s(_vm.taskProgressData.totalTaskNum) + "个")
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "course_task_progress_left" },
            [
              _c("el-progress", {
                attrs: {
                  "stroke-width": 7,
                  percentage: _vm.taskProgressData.progress
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "course_task_progress_right" }, [
            _c("p", [
              _c("span", [
                _c("i", [_vm._v(_vm._s(_vm.taskProgressData.sort))]),
                _vm._v("/" + _vm._s(_vm.taskProgressData.studentNum))
              ]),
              _vm._v("班级排名")
            ]),
            _vm._v(" "),
            _c("img", {
              attrs: {
                src: require("../../../../../../../static/images/study/statistics/ranking.png"),
                alt: ""
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "post_statistics" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm.postAccuracyStatisticsData.length > 0
            ? _c(
                "ul",
                { staticClass: "progress_list" },
                _vm._l(_vm.postAccuracyStatisticsData, function(item, i) {
                  return _c(
                    "li",
                    { key: i },
                    [
                      _c("el-progress", {
                        attrs: {
                          type: "circle",
                          percentage: item.weights
                            ? Math.ceil(item.weights * 100)
                            : 0,
                          color: item.color,
                          format: _vm.format
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(item.postName))])
                    ],
                    1
                  )
                }),
                0
              )
            : _c("div", { staticClass: "no_data" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../../../../../static/images/wujieguo.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("p", [_vm._v("暂无统计结果")])
              ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "notes_and_discuss" }, [
          _c("div", { staticClass: "notes_wrap" }, [
            _c("h2", [_vm._v("笔记")]),
            _vm._v(" "),
            _c("div", { staticClass: "note_details" }, [
              _c("img", {
                attrs: {
                  src: require("../../../../../../../static/images/study/statistics/note.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.noteData.noteNum ? _vm.noteData.noteNum : "0") +
                      "条"
                  )
                ]),
                _vm._v(" "),
                _c("p", [_vm._v("公开笔记数")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "discuss_wrap" }, [
            _c("h2", [_vm._v("讨论")]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _c("img", {
                  attrs: {
                    src: require("../../../../../../../static/images/study/statistics/theme.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("div", [
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm.discussData.themeNum
                          ? _vm.discussData.themeNum
                          : "0"
                      ) + "条"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("发表主题数")])
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("img", {
                  attrs: {
                    src: require("../../../../../../../static/images/study/statistics/reply.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("div", [
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm.discussData.replyNum
                          ? _vm.discussData.replyNum
                          : "0"
                      ) + "条"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("回复主题数")])
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("img", {
                  attrs: {
                    src: require("../../../../../../../static/images/study/statistics/comment.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("div", [
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm.discussData.commentNum
                          ? _vm.discussData.commentNum
                          : "0"
                      ) + "条"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("发表评论数")])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.isTestData
          ? _c("div", { staticClass: "test_wrap" }, [
              _c("h2", [_vm._v("测验")]),
              _vm._v(" "),
              _vm.testChartData.rows.length > 1
                ? _c("div", { staticClass: "broken_line_diagram" }, [
                    _c("div", { staticClass: "test_top" }, [
                      _c(
                        "div",
                        { staticClass: "test_left" },
                        [
                          _c("ve-line", {
                            attrs: {
                              data: _vm.testChartData,
                              extend: _vm.testExtend,
                              colors: _vm.testColors,
                              "legend-visible": false,
                              "data-empty": _vm.testDataEmpty,
                              width: "100%",
                              height: "350px"
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(1)
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "test_bot" }, [
                      _c("div", { staticClass: "test_bot_left" }, [
                        _c("h2", [_vm._v("平均分")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "test_bot_left_box" }, [
                          _c("p", [_vm._v(_vm._s(_vm.testAvgScore) + "分")]),
                          _vm._v(" "),
                          _c("p", [_vm._v("历次测验平均分")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "test_bot_right" }, [
                        _c("h2", [_vm._v("排名")]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          _vm._l(_vm.testDataList, function(item, i) {
                            return _c("li", { key: i }, [
                              _c("p", [
                                item.sort
                                  ? _c("span", [
                                      _vm._v("第" + _vm._s(item.sort) + "名")
                                    ])
                                  : _c("span", [_vm._v("未提交")]),
                                _vm._v(
                                  "\n                    （提交" +
                                    _vm._s(item.num) +
                                    "人）"
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", { attrs: { title: item.paperName } }, [
                                _vm._v(_vm._s(item.paperName))
                              ])
                            ])
                          }),
                          0
                        )
                      ])
                    ])
                  ])
                : _c("div", { staticClass: "single_test_diagram" }, [
                    _c("div", [
                      _c("p", [_vm._v(_vm._s(_vm.singleTestData.paperName))]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("班级排名："),
                        _c("span", [
                          _vm._v(
                            "第" +
                              _vm._s(
                                _vm.singleTestData.sort
                                  ? _vm.singleTestData.sort
                                  : _vm.singleTestData.num
                              ) +
                              "名"
                          )
                        ]),
                        _vm._v(
                          "（提交" + _vm._s(_vm.singleTestData.num) + "人）"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("ul", [
                      _c(
                        "li",
                        [
                          _c("el-progress", {
                            attrs: {
                              type: "circle",
                              percentage: _vm.singleTestData.score,
                              color: "#03D57C"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.singleTestData.score) + "分")
                          ]),
                          _vm._v(" "),
                          _c("p", [_vm._v("我的分数")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c("el-progress", {
                            attrs: {
                              type: "circle",
                              percentage: _vm.singleTestData.maxScore,
                              color: "#FF6464"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.singleTestData.maxScore) + "分")
                          ]),
                          _vm._v(" "),
                          _c("p", [_vm._v("班级最高分")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c("el-progress", {
                            attrs: {
                              type: "circle",
                              percentage: _vm.singleTestData.avgScore,
                              color: "#B95AFF"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.singleTestData.avgScore) + "分")
                          ]),
                          _vm._v(" "),
                          _c("p", [_vm._v("班级平均分")])
                        ],
                        1
                      )
                    ])
                  ])
            ])
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "student_training_right",
        style: "height:" + (_vm.height - 90) + "px"
      },
      [
        _c("h2", [_vm._v("学习轨迹")]),
        _vm._v(" "),
        _vm.activities.length > 0
          ? _c(
              "el-timeline",
              { staticClass: "timeline_ul" },
              _vm._l(_vm.activities, function(activity, index) {
                return _c(
                  "el-timeline-item",
                  {
                    key: index,
                    attrs: {
                      icon: activity.icon,
                      type: activity.type,
                      color: activity.color,
                      size: activity.size,
                      timestamp: activity.timestamp,
                      placement: "top"
                    }
                  },
                  [
                    _c("div", { staticClass: "timeline_card" }, [
                      _c("p", [_vm._v(_vm._s(activity.content))]),
                      _vm._v(" "),
                      activity.type == "1"
                        ? _c("img", { attrs: { src: _vm.picture } })
                        : activity.type == "2"
                        ? _c("img", { attrs: { src: _vm.file } })
                        : activity.type == "3"
                        ? _c("img", { attrs: { src: _vm.audio } })
                        : activity.type == "4"
                        ? _c("img", { attrs: { src: _vm.video } })
                        : activity.type == "5"
                        ? _c("img", { attrs: { src: _vm.zip } })
                        : activity.type == "6"
                        ? _c("img", { attrs: { src: _vm.question } })
                        : activity.type == "7"
                        ? _c("img", { attrs: { src: _vm.paper } })
                        : activity.type == "8"
                        ? _c("img", { attrs: { src: _vm.file } })
                        : activity.type == "9"
                        ? _c("img", { attrs: { src: _vm.file } })
                        : activity.type == "10"
                        ? _c("img", { attrs: { src: _vm.file } })
                        : activity.type == "11"
                        ? _c("img", { attrs: { src: _vm.file } })
                        : _c("img", { attrs: { src: _vm.file } })
                    ])
                  ]
                )
              }),
              1
            )
          : _c("div", { staticClass: "no_data" }, [
              _c("img", {
                attrs: {
                  src: require("../../../../../../../static/images/wujieguo.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("暂无学习轨迹")])
            ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top_title" }, [
      _c("h2", [_vm._v("分岗位正确率统计")]),
      _vm._v(" "),
      _c("div", { staticClass: "level_list" }, [
        _c("ul", [
          _c("li", [_c("i"), _c("span", [_vm._v("优秀（80%-100%）")])]),
          _vm._v(" "),
          _c("li", [_c("i"), _c("span", [_vm._v("良好（60%-79%）")])]),
          _vm._v(" "),
          _c("li", [_c("i"), _c("span", [_vm._v("中等（40%-59%）")])]),
          _vm._v(" "),
          _c("li", [_c("i"), _c("span", [_vm._v("待加强（0%-39%）")])])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [_c("span", [_vm._v("我的分数")]), _c("i")]),
      _vm._v(" "),
      _c("li", [_c("span", [_vm._v("班级最高分")]), _c("i")]),
      _vm._v(" "),
      _c("li", [_c("span", [_vm._v("班级平均分")]), _c("i")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ca0bdc4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ca0bdc4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/statistics/student/studentTraining.vue
// module id = null
// module chunks = 